import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Actions\Pages\SubmitFeedback::__invoke
* @see app/Actions/Pages/SubmitFeedback.php:17
* @route '/feedback'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/feedback',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Pages\SubmitFeedback::__invoke
* @see app/Actions/Pages/SubmitFeedback.php:17
* @route '/feedback'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Pages\SubmitFeedback::__invoke
* @see app/Actions/Pages/SubmitFeedback.php:17
* @route '/feedback'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

const feedback = {
    store: Object.assign(store, store),
}

export default feedback